export default "__VITE_ASSET__BbHCxI6C__"